module.exports = __webpack_public_path__ + "images/001 Compris TM clr.png";